import React from 'react';

import './index.sass';

export default () => (
	<div className="Spinner__wrapper">
		<div className="Spinner" />
	</div>
);
